import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import {
    Store,
    StoreModule
} from '@ngrx/store';

import * as fromFavourites from '../favourites/store';
import { SharedModule } from '../shared';
import { FavouritesEffects } from './store/items/items.effects';
import { FavouritesBadgeComponent } from './containers/favourites-badge/favourites-badge.component';
import { State } from './store';
import { Angulartics2Module } from 'angulartics2';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature('favourites',
            fromFavourites.reducers,
            { metaReducers: fromFavourites.metaReducers }),
        EffectsModule.forFeature([
            FavouritesEffects]),
        Angulartics2Module
    ],
    declarations: [FavouritesBadgeComponent],
    exports: [
        FavouritesBadgeComponent
    ]
})
export class FavouritesModule {
    constructor() {}
}
